import {
  CHANGE_PRODUCT,
  APPLY_CONDITION_TO_CANVAS,
  INIT_CANVAS,
  SAVE_DESIGN,
  START,
  SUCCESS,
  FAIL,
  CLEAR_DESIGN,
  ADD_TEXT,
  GET_REALISM,
  AUTO_SAVE_DESIGN
} from "../constants/action-types";

export default (product = {loading: true, loaded: false}, action) => {
  const {type, response, error} = action;
  switch (type) {
    case CHANGE_PRODUCT + START:
      return {...product, loading: true, loaded: false};
    case CHANGE_PRODUCT + SUCCESS:
      return {...response.product, loading: false, loaded: true};
    case CHANGE_PRODUCT + FAIL:
      return {...product, loading: false, loaded: true, error};

    case INIT_CANVAS + START:
      return {...product, loading: true, loaded: false};
    case INIT_CANVAS + SUCCESS:
      return {...product, loading: false, loaded: true};
    case INIT_CANVAS + FAIL:
      return {...product, loading: false, loaded: true, error};

    case APPLY_CONDITION_TO_CANVAS + START:
      return {...product, loading: true, loaded: false};
    case APPLY_CONDITION_TO_CANVAS + SUCCESS:
      return {...product, loading: false, loaded: true};
    case APPLY_CONDITION_TO_CANVAS + FAIL:
      return {...product, loading: false, loaded: true, error};

    case SAVE_DESIGN + START:
      return {...product, loading: true, loaded: false};
    case SAVE_DESIGN + SUCCESS:
      return {...response.product, loading: false, loaded: true};
    case SAVE_DESIGN + FAIL:
      return {...product, loading: false, loaded: true, error};

    case AUTO_SAVE_DESIGN + START:
      return {...product};
    case AUTO_SAVE_DESIGN + SUCCESS:
      return {...response.product};
    case AUTO_SAVE_DESIGN + FAIL:
      return {...product, loading: false, loaded: true, error};

    case CLEAR_DESIGN + START:
      return {...product, loading: true, loaded: false};
    case CLEAR_DESIGN + SUCCESS:
      return {...product, loading: false, loaded: true};
    case CLEAR_DESIGN + FAIL:
      return {...product, loading: false, loaded: true, error};

    case GET_REALISM + START:
      return {...product, loading: true, loaded: false};
    case GET_REALISM + SUCCESS:
      return {...product, loading: false, loaded: true};
    case GET_REALISM + FAIL:
      return {...product, loading: false, loaded: true, error};

    case ADD_TEXT + START:
      return {...product, loading: true, loaded: false};
    case ADD_TEXT + SUCCESS:
      return {...product, loading: false, loaded: true};
    case ADD_TEXT + FAIL:
      return {...product, loading: false, loaded: true, error};
  }
  return product;
};
